import { createRouter, createWebHistory } from "vue-router";

import AuthPage from "@/views/AuthPage.vue";
import AppPage from "@/views/AppPage.vue";
import SharePage from "@/views/SharePage.vue";
import FranchisePage from "@/views/FranchisePage.vue";
import RootPage from "@/views/RootPage.vue";

import MesLogements from "@/pages/MesLogements.vue";
import MonLogement from "@/pages/MonLogement.vue";
import MesTravaux from "@/pages/MesTravaux.vue";
import MesEquipements from "@/pages/MesEquipements.vue";
import MesPartages from "@/pages/MesPartages.vue";
import AjouterLogement from "@/pages/AjouterLogement.vue";
import AjouterPartage from "@/pages/AjouterPartage.vue";
import MesAbonnements from "@/pages/MesAbonnements.vue";

import MaFranchise from "@/franchise-pages/MaFranchise.vue";
import AjouterCIL from "@/franchise-pages/AjouterCIL.vue";
import MonAgence from "@/franchise-pages/MonAgence.vue";
import AjouterCompte from "@/franchise-pages/AjouterCompte.vue";

import MyAdmin from "@/root-pages/MyAdmin.vue";
import AllUsers from "@/root-pages/AllUsers.vue";
import AllAgencies from "@/root-pages/AllAgencies.vue";
import AllCILs from "@/root-pages/AllCILs.vue";
import AjouterCIL2 from "@/root-pages/AjouterCIL.vue";
import AjouterAgence from "@/root-pages/AjouterAgence.vue";
import AjouterFranchiseCompte from "@/root-pages/AjouterFranchiseCompte.vue";

const routes = [
    { path: "/login", component: AuthPage, props: { defaultForm: "login" } },
    { path: "/register", component: AuthPage, props: { defaultForm: "register" } },
    { path: "/verification/:md5", component: AuthPage, props: (route) => ({ defaultForm: "verification", md5: route.params.md5 }) },
    { path: "/reset/:md5", component: AuthPage, props: (route) => ({ defaultForm: "reset", md5: route.params.md5 }) },
    { path: "/forgot-password", component: AuthPage, props: { defaultForm: "forgot-password" } },
    {
        path: "/",
        component: AppPage,
        children: [
            { path: "", name: "MonLogement", component: MonLogement, props: true },
            { path: "mes-logements", name: "MesLogements", component: MesLogements, props: true },
            { path: "mes-travaux", name: "MesTravaux", component: MesTravaux, props: true },
            { path: "mes-equipements", name: "MesEquipements", component: MesEquipements, props: true },
            { path: "mes-partages", name: "MesPartages", component: MesPartages, props: true },
            { path: "ajouter", name: "AjouterLogement", component: AjouterLogement, props: true },
            { path: "mes-partages/ajouter", name: "AjouterPartage", component: AjouterPartage, props: true },
            { path: "profil/abonnements", name: "MesAbonnements", component: MesAbonnements, props: true },
        ],
    },
    { path: "/partage/:shareID", component: SharePage, props: (route) => ({ shareID: route.params.shareID }) },
    {
        path: "/franchise/",
        component: FranchisePage,
        children: [
            { path: "", name: "MaFranchise", component: MaFranchise, props: true },
            { path: "ajouter", name: "AjouterCIL", component: AjouterCIL, props: true },
            { path: "mon-agence", name: "MonAgence", component: MonAgence, props: true },
            { path: "ajouter-compte", name: "AjouterCompte", component: AjouterCompte, props: true },
        ],
    },
    {
        path: "/mondomicil-admin/",
        component: RootPage,
        children: [
            { path: "", name: "MyAdmin", component: MyAdmin, props: true },
            { path: "users", name: "AllUsers", component: AllUsers, props: true },
            { path: "agencies", name: "AllAgencies", component: AllAgencies, props: true },
            { path: "cils", name: "AllCILs", component: AllCILs, props: true },
            { path: "ajouter-cil", name: "AjouterCIL2", component: AjouterCIL2, props: true },
            { path: "ajouter-agence", name: "AjouterAgence", component: AjouterAgence, props: true },
            { path: "franchise/ajouter", name: "AjouterFranchiseCompte", component: AjouterFranchiseCompte, props: true },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
